var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChartBarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,3 L3,21 L21,21 L21,3 L3,3 Z M5,5 L19,5 L19,19 L5,19 L5,5 Z M7,7 L7,17 L9,17 L9,7 L7,7 Z M11,11 L11,17 L13,17 L13,11 L11,11 Z M15,9 L15,17 L17,17 L17,9 L15,9 Z",
    fill: "#1A1A1A",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChartBarActive);
export default __webpack_public_path__ + "static/media/icon-chart-bar-active.b44434f4ff260bd645d4e2b0c6e101b3.svg";
export { ForwardRef as ReactComponent };